import * as React from 'react'
import { sbEditable } from '@storyblok/storyblok-editable'
import {
  BlogMediaCaption,
  BlogMediaCopyright,
  BlogMediaElement,
  BlogMediaFigure,
  BlogMediaFooter,
  BlogMediaWrapper,
} from '../../components/Blog/MediaElement'

export const ImageVideo = ({ blok }) => {
  const { alt, is_external_url, title, copyright, source, filename } = blok.mediaAsset || {}
  const isVideo = !!is_external_url
  const mediaCaption = title

  const copyRightAndSource: string[] = []

  if (copyright) {
    copyRightAndSource.push(`© ${copyright}`)
  }

  if (source) {
    copyRightAndSource.push(source)
  }

  const { imageFromFrameAt } = blok;

  return (
    <BlogMediaWrapper {...sbEditable(blok)}>
      <BlogMediaFigure>
        <BlogMediaElement mediaSrc={filename} isVideo={isVideo} alt={alt} title={title} imageFromFrameAt={imageFromFrameAt || 0
        } />

      </BlogMediaFigure>
    </BlogMediaWrapper>
  )
}
